export const PAGE_HEADER_HEIGHT = '64px'
export const NAVBAR_MOBILE_HEIGHT = '64px' // TODO: remove
export const NAVBAR_WIDTH = '70px' // TODO: Remove
export const CONTENT_MAX_WIDTH = '1024px'
